// extracted by mini-css-extract-plugin
export default {"container":"Input_container__LwTub","small":"Input_small__RBu1r","input":"Input_input__k5Ctk","withLabel":"Input_withLabel__l3iHy","label":"Input_label__U9NhE"};